import React, { useState } from 'react';
import axios from 'axios';

function Login({ onLogin, loginError }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    // Sende garantiert nur Strings an onLogin
    onLogin(
      typeof username === 'string' ? username : (username?.username || ''),
      typeof password === 'string' ? password : ''
    );
    setLoading(false);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen pt-16">
      <div className="bg-white rounded shadow-lg p-8 w-full max-w-3xl">
        <form onSubmit={handleSubmit} className="w-full max-w-3xl mx-auto">
          <h2 className="text-2xl font-bold mb-6 text-center">Login</h2>
          <div className="mb-4">
            <label className="block mb-2 text-sm font-medium text-gray-700">Benutzername</label>
            <input
              type="text"
              autoComplete="username"
              value={typeof username === 'string' ? username : (username?.username || '')}
              onChange={e => setUsername(String(e.target.value))}
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring"
              required
            />
          </div>
          <div className="mb-6">
            <label className="block mb-2 text-sm font-medium text-gray-700">Passwort</label>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded focus:outline-none focus:ring"
              required
            />
          </div>
          {(error || loginError) && <div className="mb-4 text-red-600 text-sm">{error || loginError}</div>}
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-2 rounded font-semibold hover:bg-blue-700 transition flex items-center justify-center"
            disabled={loading}
          >
            {loading ? (
              <>
                <svg className="animate-spin h-5 w-5 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                </svg>
                Einloggen...
              </>
            ) : 'Login'}
          </button>
        </form>
      </div>
      {/* Kontaktblöcke unterhalb der Login-Form */}
      <div className="flex flex-col md:flex-row gap-6 mt-8 w-full max-w-3xl justify-center">
        <div className="flex-1 shadow-lg text-sm text-gray-900" style={{ background: 'white', padding: '24px', borderRadius: '4px', minWidth: '240px' }}>
          <nobr><b>Schwarzwald Tourismus GmbH</b><br /></nobr>
          Stefanie Skorek<br />
          Projektmanagement KONUS<br />          digital &amp; Marketing<br />
          Kompetenzzentrum Tourismus<br />
          Wiesentalstraße 5<br />
          79115 Freiburg<br />
          Tel.: +49 761 89646 31<br />
          Fax: +49 761 89646 70<br />
          skorek@schwarzwald-tourismus.info<br />
          <a href="https://www.schwarzwald-tourismus.info" className="text-blue-700 underline" target="_blank" rel="noopener noreferrer">https://www.schwarzwald-tourismus.info</a>
        </div>
        <div className="flex-1 shadow-lg text-sm text-gray-900" style={{ background: 'white', padding: '24px 30px 24px 24px', borderRadius: '4px', minWidth: '240px' }}>
          <nobr><b>RIECO DRUCK + DATEN GmbH &amp; Co. KG</b><br />
          Saskia Baum<br />
          Industriestraße 28<br />
          67269 Grünstadt<br />
          Tel.: +49 6359 9340 11<br />
          Fax: +49 6359 9340 71<br />
          saskia.baum@rieco.de<br /></nobr>
          <a href="https://www.rieco.de" className="text-blue-700 underline" target="_blank" rel="noopener noreferrer">https://www.rieco.de</a>
        </div>
      </div>
    </div>
  );
}

export default Login;
